import type { ClinicNotification } from './types';

export function visibleUnreadNotificationCount(
  notifications: readonly ClinicNotification[],
  loading: boolean,
): number {
  return loading ? 0 : notifications.filter((notification) => !notification.read).length;
}
